import WieldySidebarSection from "../WieldySidebarSection";
import React, {useEffect, useState, Fragment, useContext, useRef, useLayoutEffect} from "react";
import './SidebarChildren.scss';
import ChildDetailSidebarEntry from "./ChildDetailSidebarEntry";

import {useSetRecoilState} from "recoil";
import {currentChildAtom} from "root/recoil/childId";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {getMyChildren} from "root/DataFunctions/ChildDataFns";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import useModalUpdateChild from "root/Modals/UpdateChildDetails/useModalUpdateChild";
import {getCanCreateChildren} from "root/DataFunctions/PageContentRoles";
import {useGlobalContext} from "root/contexts/GlobalContext";

const SidebarChildren = ({height, role}) =>
{
    const [ children, setChildren ] = useState ( { loading: true, data : [] } ) ;
    const setCurrentChild = useSetRecoilState(currentChildAtom);

    const { userType } = useGlobalContext() ;
    const sideNav = useRef ( null ) ;
    const createSection = useRef ( null ) ;

    // Open add child modal
    const [renderAddChildModal, showAddChildModal] = useModalUpdateChild((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })
    const getActiveChildren = ()  =>{
        getMyChildren(  'all',(response) =>
        {
            const children = getDataFromResponse( response ) ;
            setChildren ( { loading: false, data: children}) ;

            // Set the recoil currentChildAtom to the first child
            setCurrentChild(children[0]);
        });
    }

    useEffect(() => {
        getActiveChildren();
    }, []);

    // LIF-1687 prevent My children section from being displayed if the viewing user has NO permissions to ANY children
    const areAnyChildrenContactable = () =>
    {
        return children.data.reduce((accumulator, child) =>
        {
            const hasRole = child.is_contributor === true || child.is_messager === true || child.is_editor === true || child.is_manager === true;

            return hasRole || accumulator === true ;

        }, false);
    }

    const childList = () =>
    {
        // LIF-1687 prevent children from being displayed if the viewing user has NO permissions
        return children.data.filter ((child) =>
        {
            return child.is_contributor === true || child.is_messager === true || child.is_editor === true || child.is_manager === true;
        }).map ((child, index) =>
        {
            return (
                <ChildDetailSidebarEntry keyName={child.unenc_child_uid} childDetails={child} key={child.unenc_child_uid} role={role}/>
            )
        });
    }

    const clickHandler = (event) =>
    {
        showAddChildModal(null, 'create');
    }

    const {top } = sideNav.current === null ? 0 : sideNav.current.getBoundingClientRect();

    const childContainerMaxHeight = (height - top) + 'px' ;

    //
    if ( areAnyChildrenContactable() === true )
    {
        return (
            <Fragment>
                <div className="dt-side-nav" ref={sideNav}>
                    <WieldySidebarSection title='My Children' key='children'>
                        <div className="child-sidebar-container"
                             style={{maxHeight: childContainerMaxHeight, overflowY: 'scroll'}}>
                            {children.loading === false && childList()}
                        </div>
                    </WieldySidebarSection>

                    {getCanCreateChildren(userType) === true &&
                        <div ref={createSection}>
                            <WieldySidebarSection title='Add New Child' key='newChild'>
                                <WieldySidebarClick modal={(event) => clickHandler(event)} title='Child'
                                                    iconName='icon-add-circle' iconSize='icon-xl' keyName='root1'
                                                    key='c1'/>
                            </WieldySidebarSection>
                        </div>
                    }
                </div>
                {renderAddChildModal()}
            </Fragment>
        )
    }
    else
    {
        return null ;
    }
}

export default SidebarChildren ;
